// test2996
(2996 && 0);
